<template>
    <div class="home">
        <div class="is-pulled-right"><button class="button is-info is-small" @click="$emit('backToMenu')">Back Without Saving </button></div><br /><br />

        <div class="notification is-warning " v-if="loading==true">
            <p>Loading ...</p>
        </div>

        <div class="box" v-if="loading==false">	
            <h4 class="title is-4">Union Information</h4>
            
            <form @submit.prevent="updateUnion" >
                <div class="field">
                    <label class="label">Union Name</label>
                    <div class="control">
                        <input class="input" type="text" v-model="member.union_name" autofocus required maxlength="100">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Union Number</label>
                    <div class="control">
                        <input class="input" type="text" v-model="member.union_number" autofocus required maxlength="100">
                    </div>
                </div>

              
                <div class="field is-grouped">
                    <div class="control">
                        <button class="button is-success" :disabled="working===true">Update Union Details</button>
                    </div>
                </div>
            </form>
            
          </div>
          
      </div>
  </template>

<script>
    import UtilityService from '@/services/UtilityService.js';
    import MemberApplicationService from '@/services/MemberApplicationService.js';
    
    export default {
      name: 'ViewApplication',
        mixins: [],
        props: ['application'],
        data: function () {
            return {
                   application_code : this.$route.params.id,
                   loading:false,
                   accessToken: '',
                   member: [],
                   
            }
        },
        created() {
          
          this.getApplicationUnion()
          
        },
        methods: {

            async getApplicationUnion() {
                this.loading = true;
                UtilityService.getSimpleApiData(this.accessToken, "web/applications/" + this.application_code + '/union').then(
                    response => {
                        this.member = response 
                        this.loading = false;
                    }
                );
            },
           
            async updateUnion() {
                this.working = true
                var formdata = { 
                    _method: 'patch',
                    union_name : this.member.union_name,
                    union_number : this.member.union_number
                    
                }; 

                
                MemberApplicationService.updateUnion (this.accessToken, this.application_code, formdata)
                .then((response) => {
                    console.log(response)
                    this.$emit('backToMenu')
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                            alert("Something went wrong. Make sure you have filled in all the fields. ")
                        }
                        else if(error.response.status === 406)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                            alert("The information passed was not valid. Please double check and try again.")
                        }
                        else if(error.response.status === 404)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                            alert("The application code passed in was not valid. Please double check and try again.")
                        }
                        else {
                            alert("Something went wrong saving your details. Please try again ot contact us and we will help you sort the issue.")
                        }
                        
                        this.working = false
                });
                

                
            },
            
           
        }
    }
    </script>